import { Component } from '@angular/core';

@Component({
  selector: 'app-contract-settings',
  templateUrl: './contract-settings.component.html',
  styleUrl: './contract-settings.component.scss'
})
export class ContractSettingsComponent {
   tabTriangle:string='configtopic';

   showTriangle(tab:any){
    this.tabTriangle=tab;
   }
}
